import { FunctionComponent, ReactNode } from "react";

export const Opacity: FunctionComponent<{ children: ReactNode }> = ({ children }) => <span style={{ opacity: 0.25 }}>{children}</span>;
